import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CreateUpdateChannelUserEntity } from '../../domain/entities/CreateUpdateChannelUserEntity'

export class CreateUpdateChannelUserModel extends CreateUpdateChannelUserEntity {
  userId?: string
  channelIds?: Array<number> | null
  constructor(dataDto: CreateUpdateChannelUserEntity) {
    super()
    mapEntityProperties<CreateUpdateChannelUserModel>(this, dataDto, {
      exclude: ['channels', 'user'],
      map: {
        userId: dataDto.user?.id,
        channelIds: dataDto.channels?.map((channel) => channel.id)
      }
    })
  }
}
